// extracted by extract-css-chunks-webpack-plugin
module.exports = {"news_box":"news_box-29jvuXf6 clearfix","box_r":"box_r-6cik35OG","d_box":"d_box-3s6frQJI"};